import { Pipe, PipeTransform } from '@angular/core';

import { FertiliserOrderplan, Product } from '../models';

@Pipe({
    name: 'cropAidArticlesFilter',
    pure: false,
    standalone: false,
})
export class CropAidArticlesFilterPipe implements PipeTransform {
  transform(items: Product[], filter: FertiliserOrderplan): Product[] {
    if (!items || !filter) {
      return items;
    }
    // filter items array, items which match and return true will be
    // kept, false will be filtered out
    return items.filter((item) => item.id === filter.cropAidId).sort((a, b) => a.amount < b.amount ? -1 : 1);
  }
}
